import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveProducts, receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import { Article } from '@ttstr/api';
import FilteredMasonry from './FilteredMasonry';

// wird nicht mehr gebraucht: Header soll ganz raus
// import MerchstandImages from './assets/images/MerchstandImages';

interface RouteParams {
  readonly id: string;
}

type Props = {
  /**
   * productFilter can be used if you want a Route to a dedicated page for special merch/products.
   *
   * Example:
   * You want a page only with merch that has the tag id 1234.
   * The function for productFilter would then be
   *  p => p.tag_ids.includes(1234)
   *
   * Then create a route in App.tsx with
   * <Route exact path="/specialmerch" render={()=> <ProductListing productFilter={p => p.tag_ids.includes(1234)} />} />
   */
  productFilter?: (p: Article) => any;
};

const Home: React.FC<Props> = ({ productFilter = (p) => p }) => {
  const { t } = useTranslation();
  const params = useParams<RouteParams>();
  const { products, loadingProducts, tickets, loadingTickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts, receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  if (!productFilter && params?.id) {
    productFilter = (p) => p.category_ids.includes(Number(params.id));
  }

  React.useEffect(() => {
    receiveProducts();
    receiveTickets();
  }, [language]);

  return (
    <article className="mb-5">
      <Helmet>
        <title>{t(`PRODUCTS.TITLE`)}</title>
        <body className="landing-page" />
      </Helmet>

      <Container fluid className="header-image" />

      <Container className="list-page mb-5">
        <h1 className="mt-5 mb-1 text-center">Bestseller CBD Blüten <small>CBD Premium Qualität</small></h1>
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>
        <Masonry
          id="product-listing"
          products={products.filter((p) => p.category_ids.includes(4618))}
          columnClassName="col-sm-12 col-md-6 col-lg-4"
          filters="off"
          showFormerPrice
          showSubtitle
        />
      </Container>

      {/* <Container fluid className="header-image samen" />

      <Container className="list-page mb-5">
        <h1 className="mt-5 mb-1 text-center">Cannabis Samen von Ottmanns <small>Jetzt bestellen</small></h1>
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>
        <Masonry
          id="product-listing"
          products={products.filter((p) => p.category_ids.includes(4617))}
          columnClassName="col-sm-12 col-md-6 col-lg-4"
          filters="off"
          showFormerPrice
          showSubtitle
        />
      </Container> */}

      <Container fluid className="header-image stuff" />

      <Container className="list-page mb-5">
        <h1 className="mt-5 mb-1 text-center">Rauchzubehör <small>Alles was du für einen guten Rausch brauchst...</small></h1>
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>
        <Masonry
          id="product-listing"
          products={products.filter((p) => p.category_ids.includes(4621))}
          columnClassName="col-sm-12 col-md-6 col-lg-4"
          filters="off"
          showFormerPrice
          showSubtitle
        />
      </Container>

      <Container fluid className="header-image merch" />

      <Container className="list-page mb-5">
        <h1 className="mt-5 mb-1 text-center">Ottmann Merch <small>Shop den Ottmann Look</small></h1>
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>
        <Masonry
          id="product-listing"
          products={products.filter((p) => p.category_ids.includes(4613))}
          columnClassName="col-sm-12 col-md-6 col-lg-4"
          filters="off"
          showFormerPrice
          showSubtitle
        />
      </Container>

      <Container>
        <div className="row">
          <h1 className="mt-5 d-block text-center w-100">CBD Online Shop Ottmann by SSIO</h1>
          <p className="mt-4 mb-4 text-center">Bei uns bekommt ihr <strong>das Original</strong>, wenn es um <strong>hochwertige Produkte aus Hanf</strong> geht. <strong>Ottmanns CBD</strong> steht für <strong>das Beste aus der Natur für Körper und Geist</strong>. Genießt unser <strong>exklusives Sortiment hochwertiger CBD-Blüten</strong> und <strong>bestellt jetzt mit wenigen Klicks online</strong>.</p>
          <div className="col d-flex flex-row iconbar mb-5">
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_02_300x.avif')} alt="" /></div>
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_01_300x.avif')} alt="" /></div>
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_03_300x.avif')} alt="" /></div>
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_04_300x.avif')} alt="" /></div>
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_05_300x.avif')} alt="" /></div>
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_06_300x.avif')} alt="" /></div>
            <div className="pr-1"><img src={require('./assets/images/icons/Ottmann_Shop_Icons_07_300x.avif')} alt="" /></div>
            <div className=""><img src={require('./assets/images/icons/Ottmann_Shop_Icons_08_300x.avif')} alt="" /></div>
          </div>
        </div>
      </Container>

    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products } = state.Products;
  const loadingProducts = state.Products.loading;
  const { tickets } = state.Tickets;
  const loadingTickets = state.Tickets.loading;
  return {
    products,
    loadingProducts,
    tickets,
    loadingTickets,
  };
};

const mapDispatchToProps = {
  receiveProducts,
  receiveTickets,
};

export default React.memo(Home);
